function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 23C0 10.3021 10.2983 0 23 0C35.7017 0 46 10.3021 46 23C46 35.7054 35.7017 46 23 46C10.2983 46 0 35.7054 0 23ZM43.0323 23.0001C43.0323 11.878 34.0012 2.96784 23 2.96784C11.9268 2.96784 2.96777 11.945 2.96777 23.0001C2.96777 34.077 11.9411 43.0324 23 43.0324C34.0725 43.0324 43.0323 34.0634 43.0323 23.0001ZM21.9342 11.1291H24.0654C24.6981 11.1291 25.2037 11.656 25.1773 12.2883L24.5281 27.869C24.5033 28.4651 24.0129 28.9355 23.4162 28.9355H22.5834C21.9868 28.9355 21.4963 28.465 21.4715 27.869L20.8223 12.2883C20.796 11.656 21.3015 11.1291 21.9342 11.1291ZM20.4033 33.3871C20.4033 31.9529 21.5659 30.7903 23.0001 30.7903C24.4343 30.7903 25.5969 31.9529 25.5969 33.3871C25.5969 34.8212 24.4343 35.9839 23.0001 35.9839C21.5659 35.9839 20.4033 34.8212 20.4033 33.3871Z",
  fill: "currentColor"
});

var SvgIcAlert = function SvgIcAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 46 46",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-alert.2971da09.svg";
export { ForwardRef as ReactComponent };